import moment from 'moment'
import _cloneDeep from 'lodash/cloneDeep'
import store from '@/store'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { authHeader } from '@/services/auth'

function addProduits (produits) {
  store.commit('setProduits', produits)
}

function removeProduits () {
  store.commit('setProduits', null)
}
function removePopupProduitSfc () {
  store.commit('setPopupSfcVue', false)
}

export async function getUsers (filters) {
  const user = store.getters.getAdvertiser
  if (user && typeof user === 'object' && user.advertiser !== undefined) {
    filters.advertiser = user.advertiser
  }
  const qs = require('qs')
  const params = {
    headers: authHeader('application/ld+json'),
    params: filters,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false })
    }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/users', params)
    .then(response => {
      return {
        total: response.data['hydra:totalItems'],
        list: response.data['hydra:member']
      }
    })
    .catch(error => {
      // this.errored = true
      return { type: 'error', message: error }
    })
}

export async function exportUsers (filters) {
  const clonedFilters = _cloneDeep(filters)

  clonedFilters.pagination = false
  clonedFilters.groups = ['export']
  delete clonedFilters.itemsPerPage

  const qs = require('qs')

  const params = {
    responseType: 'blob',
    params: clonedFilters,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false })
    }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/users.csv', params)
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([response.data]))
      link.setAttribute('download', 'export_utilisateurs_' + moment().format('DD_MM_YYYY_HH_mm_ss') + '.xls') // or any other extension
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function createUser (user) {
  user.username = 'auto'
  user.mainAccount = false

  return HTTP_HYPER_ESPACE_BACKEND.post('/users', user)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function updateUser (user) {
  return HTTP_HYPER_ESPACE_BACKEND.put('/users/' + user.id, user)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

// $stopPopupSfc
export async function putStopPopupSfc (user) {
  const params = {
    stopPopupSfc: true,
    splashScreenAlreadySeen: true
  }

  return HTTP_HYPER_ESPACE_BACKEND.put('/users/' + user.id, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

// $stopPopupSfc
export async function putStopPopupBiensVendus (user) {
  const params = {
    stopPopupBiensVendus: true
  }

  return HTTP_HYPER_ESPACE_BACKEND.put('/users/' + user.id, params)
    .then(response => {
      return response
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function getUrlSFC (user) {
  const params = {
    login: 'ag' + user.advertiser
  }

  return HTTP_HYPER_ESPACE_BACKEND.post('/sfc/autolink', params)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function checkResetPasswordStatusSFC (filters) {
  const params = filters

  return HTTP_HYPER_ESPACE_BACKEND.post('/sfc/check_reset_password_status', params)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function deleteUserContact (userId) {
  return HTTP_HYPER_ESPACE_BACKEND.delete('/users/' + userId)
}

export async function portailClientConnect () {
  const params = {}
  return HTTP_HYPER_ESPACE_BACKEND
    .get('/portail-client-connect', params)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}
